import {
  ChargeStates,
  type ChargeStatus,
  ChargeStatusSchema,
} from '../billing/charge-status.ts'

export const PaymentStates = ChargeStates
export const PaymentStatusSchema = ChargeStatusSchema

export type PaymnetStatus = ChargeStatus
